import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const animateMainvisual = () => {
  const timelineMainVisual = gsap.timeline({
    scrollTrigger: {
      trigger: '#mainvisual',
      pin: true,
      scrub: 1,
      end: '200%',
    },
  })

  timelineMainVisual
    .set(
      [
        '#mainvisual-subtitle .mainvisual__subtitle-text:first-child',
        '#mainvisual-subtitle .mainvisual__subtitle-text:last-child',
      ],
      {
        display: 'block',
      }
    )
    .to(
      '#mainvisual-title',
      {
        xPercent: '50',
        y: '-20vh',
        opacity: 0,
        duration: 4,
        scale: 2,
        force3D: false,
      },
      0
    )
    .to(
      '#mainvisual-subtitle .mainvisual__subtitle-text:first-child',
      {
        xPercent: '-80',
        y: '-16vh',
        autoAlpha: 0,
        display: 'none',
        duration: 4,
        force3D: false,
      },
      0
    )
    .to(
      '#mainvisual-subtitle .mainvisual__subtitle-text:last-child',
      {
        xPercent: '50',
        y: '-28vh',
        scale: 20,
        duration: 4,
        force3D: false,
      },
      0
    )
    .to(
      '#mainvisual-subtitle .mainvisual__subtitle-text:last-child',
      {
        autoAlpha: 0,
        display: 'none',
        force3D: false,
      },
      3
    )
}

export default animateMainvisual
